<template>
  <section class="custom-wrapper">
    <div class="row">
      <div class="col-md-12">
        <button v-if="!isReadOnly" class="btn btn-success btn-sm mb-2" @click="add">Add</button>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <span>Sub-Category Items:</span>
        <ul class="custom-list">
          <li v-for="item in matrix.items" :key="item.id">
            <div v-if="!item.isRemove" class="row">
              <div class="col-md-11">
                <span v-if="isReadOnly">{{ item.item }}</span>
                <input v-else :id="item.id" :value="item.item" class="form-control" @blur="save" />
              </div>
              <div class="col-md-1">
                <a v-if="!isReadOnly" href="#" class="custom-remove" @click="remove(item)">
                  <i class="fas fa-times text-danger"></i>
                </a>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { adasmatrixStore } from '@/stores/adasmatrix'
export default {
  name: 'MatrixCategories',
  props: {
    matrix: Object,
    isReadOnly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      items: []
    }
  },
  emits: ['changed'],
  computed: {
    ...mapState(adasmatrixStore, ['adasmatrix'])
  },
  methods: {
    ...mapActions(adasmatrixStore, ['updateAdasMatrixItem']),
    loadItems() {
      this.items = []
      if (this.matrix !== undefined && this.matrix !== null) {
        this.matrix.items.forEach((element) => {
          if (!element.isRemove) {
            this.items.push(element)
          }
        })
      }
    },
    prepData(item) {
      return item.item
    },
    add() {
      console.log('Adding a category item.')
      this.updateAdasMatrixItem({
        action: 'add',
        id: 0,
        value: ''
      })
      this.$emit('changed')
    },
    save(e) {
      console.log('Update Matrix Item', e)
      this.updateAdasMatrixItem({
        action: 'save',
        id: e.target.id,
        value: e.target.value
      })
      this.$emit('changed')
    },
    remove(item) {
      let $this = this
      this.updateAdasMatrixItem({
        action: 'remove',
        id: item.id,
        value: null
      })
      setTimeout(() => {
        $this.$forceUpdate()
      }, 250)
      this.$emit('changed')
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-wrapper {
  width: 100%;
}
.custom-list {
  list-style-type: none;
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 400px;
  li {
    padding: 5px;
  }
}
.custom-remove {
  width: 28px;
}
</style>
